export const SUBJECT_OPTIONS = [
  { value: "PV", label: "Photovoltaique" },
  { value: "IRVE", label: "IRVE" },
  { value: "GTB_GTC_BACS", label: "GTB / GTC / BACS" },
  { value: "DEET", label: "DEET / Decret Tertiaire" },
  { value: "CEE", label: "CEE" },
  { value: "LED", label: "LED / Relamping" },
  { value: "AUDIT", label: "Audit Energetique" },
  { value: "AUTRE", label: "Autre" },
];

export const STATUS_OPTIONS = [
  { value: "brouillon", label: "Brouillon", color: "#94A3B8" },
  { value: "a_qualifier", label: "A qualifier", color: "#F59E0B" },
  { value: "en_attente_infos", label: "En attente d'infos", color: "#F97316" },
  { value: "pret_a_envoyer", label: "Pret a envoyer", color: "#8B5CF6" },
  { value: "envoye_partenaire", label: "Envoye", color: "#3B82F6" },
  { value: "en_cours_suivi", label: "En cours de suivi", color: "#06B6D4" },
  { value: "offre_recue", label: "Offre recue", color: "#10B981" },
  { value: "signe", label: "Signe", color: "#059669" },
  { value: "perdu", label: "Perdu", color: "#EF4444" },
  { value: "archive", label: "Archive", color: "#6B7280" },
];

export const CLIENT_TYPES = [
  { value: "TPE", label: "TPE (< 10 salaries)" },
  { value: "PME", label: "PME (10-249 salaries)" },
  { value: "ETI", label: "ETI (250-4999 salaries)" },
  { value: "Grand_groupe", label: "Grand groupe (5000+)" },
  { value: "Industrie", label: "Industrie" },
  { value: "copropriete", label: "Copropriete" },
  { value: "collectivite", label: "Collectivite / Etablissement public" },
  { value: "autre", label: "Autre" },
];

// Origine du lead = champ texte libre (nom du collaborateur PDE)

export const MATURITY_OPTIONS = [
  { value: "simple_interet", label: "Simple interet" },
  { value: "besoin_identifie", label: "Besoin identifie" },
  { value: "consultation_en_cours", label: "Consultation en cours" },
  { value: "projet_avance", label: "Projet avance" },
];

export const SUBJECT_FIELDS = {
  PV: {
    label: "Photovoltaique",
    fields: [
      { name: "building_type", label: "Type de batiment", type: "select", options: ["Bureaux / Tertiaire", "Commerce / Retail", "Entrepot / Logistique", "Site industriel", "Copropriete / Residentiel collectif", "Etablissement public", "Hotellerie / Restauration", "Sante", "Enseignement", "Autre"], required: true },
      { name: "project_type", label: "Type de projet", type: "select", options: ["Toiture", "Ombriere", "Sol", "Autre"], required: true },
      { name: "available_surface", label: "Surface disponible estimee", type: "text", required: false },
      { name: "roof_type", label: "Type de couverture / toiture", type: "text", required: false },
      { name: "subscribed_power", label: "Puissance souscrite actuelle", type: "text", required: false },
      { name: "annual_consumption", label: "Consommation electrique annuelle", type: "text", required: false },
      { name: "load_curve_available", label: "Courbe de charge / factures disponibles", type: "select", options: ["Oui", "Non", "Inconnu"], required: false },
      { name: "objective", label: "Objectif du client", type: "select", options: ["Autoconsommation", "Revente", "Mixte", "Inconnu"], required: true },
      { name: "irve_on_site", label: "Presence d'IRVE sur site", type: "select", options: ["Oui", "Non"], required: false },
      { name: "constraints", label: "Contraintes connues", type: "textarea", required: false },
    ],
    suggested_attachments: ["Facture d'electricite", "Photo toiture", "Plan de masse", "Coordonnees du site"]
  },
  IRVE: {
    label: "IRVE",
    fields: [
      { name: "parking_spaces", label: "Nombre de places de parking", type: "number", required: true },
      { name: "desired_chargers", label: "Nombre de bornes souhaitees", type: "number", required: true },
      { name: "charger_type", label: "Type de bornes", type: "select", options: ["AC", "DC", "Mixte", "Inconnu"], required: true },
      { name: "charger_power", label: "Puissance des bornes souhaitee", type: "multiselect", options: ["3,7 kW (lente)", "7,4 kW (normale)", "11 kW (acceleree)", "22 kW (acceleree)", "50 kW (rapide DC)", "100 kW (ultra-rapide)", "150+ kW (HPC)"], required: false },
      { name: "usage", label: "Usage", type: "select", options: ["Flotte", "Salaries", "Visiteurs", "Public", "Mixte"], required: true },
      { name: "contract_power", label: "Puissance du contrat (kVA)", type: "text", required: false },
      { name: "supervision_needed", label: "Besoin de supervision", type: "select", options: ["Oui", "Non"], required: false },
      { name: "energy_management_needed", label: "Besoin de pilotage energetique", type: "select", options: ["Oui", "Non"], required: false },
      { name: "constraints", label: "Contraintes connues", type: "textarea", required: false },
    ],
    suggested_attachments: ["Photos parking", "Plan du site", "Facture electricite"]
  },
  GTB_GTC_BACS: {
    label: "GTB / GTC / BACS",
    fields: [
      { name: "building_type", label: "Type de batiment", type: "select", options: ["Bureaux / Tertiaire", "Commerce / Retail", "Entrepot / Logistique", "Site industriel", "Copropriete / Residentiel collectif", "Etablissement public", "Hotellerie / Restauration", "Sante", "Enseignement", "Autre"], required: true },
      { name: "tertiary_surface", label: "Surface tertiaire estimee", type: "text", required: true },
      { name: "hvac_present", label: "Systeme CVC present", type: "select", options: ["Oui", "Non"], required: true },
      { name: "hvac_power", label: "Puissance CVC si connue", type: "text", required: false },
      { name: "existing_gtb", label: "GTB/GTC existante", type: "select", options: ["Oui", "Non"], required: true },
      { name: "objective", label: "Objectif", type: "select", options: ["Mise en conformite", "Optimisation", "Renovation", "Inconnu"], required: true },
      { name: "constraints", label: "Contraintes connues", type: "textarea", required: false },
    ],
    suggested_attachments: ["Schemas techniques", "Factures", "Descriptif installations"]
  },
  DEET: {
    label: "DEET / Decret Tertiaire",
    fields: [
      { name: "building_type", label: "Type de batiment", type: "select", options: ["Bureaux / Tertiaire", "Commerce / Retail", "Entrepot / Logistique", "Site industriel", "Copropriete / Residentiel collectif", "Etablissement public", "Hotellerie / Restauration", "Sante", "Enseignement", "Autre"], required: true },
      { name: "tertiary_surface", label: "Surface tertiaire concernee", type: "text", required: true },
      { name: "multisite", label: "Monosite ou multisite", type: "select", options: ["Monosite", "Multisite"], required: true },
      { name: "reference_year_known", label: "Annee de reference connue", type: "select", options: ["Oui", "Non"], required: true },
      { name: "consumption_data_available", label: "Donnees de consommation disponibles", type: "select", options: ["Oui", "Non"], required: true },
      { name: "operat_used", label: "Plateforme OPERAT utilisee", type: "select", options: ["Oui", "Non"], required: true },
      { name: "client_need", label: "Besoin du client", type: "select", options: ["Mise en conformite", "Accompagnement", "Audit", "Strategie"], required: true },
      { name: "constraints", label: "Contraintes connues", type: "textarea", required: false },
    ],
    suggested_attachments: ["Surfaces", "Consommations", "Contact exploitant / proprietaire"]
  },
  CEE: {
    label: "CEE",
    fields: [
      { name: "project_nature", label: "Nature du projet / des travaux", type: "text", required: true },
      { name: "site", label: "Site concerne", type: "text", required: true },
      { name: "works_signed", label: "Devis deja signe", type: "select", options: ["Oui", "Non"], required: true, blocking_value: "Oui", blocking_message: "ATTENTION : Si le devis est deja signe, le projet est irrecevable pour les CEE. Les CEE doivent etre demandes AVANT la signature du devis." },
      { name: "works_started", label: "Travaux deja engages", type: "select", options: ["Oui", "Non"], required: true },
      { name: "signature_date", label: "Date previsionnelle de signature", type: "text", required: false },
      { name: "works_date", label: "Date previsionnelle de travaux", type: "text", required: false },
      { name: "equipment_type", label: "Type d'equipement concerne", type: "text", required: true },
      { name: "multi_works", label: "Multi-travaux (description des operations)", type: "textarea", required: false },
      { name: "quote_available", label: "Devis disponible", type: "select", options: ["Oui", "Non"], required: false },
      { name: "installer_identified", label: "Installateur identifie", type: "select", options: ["Oui", "Non"], required: false },
    ],
    suggested_attachments: ["Devis", "Descriptif technique", "Photo / reperage site"]
  },
  LED: {
    label: "LED / Relamping",
    fields: [
      { name: "building_type", label: "Type de batiment", type: "select", options: ["Bureaux / Tertiaire", "Commerce / Retail", "Entrepot / Logistique", "Site industriel", "Copropriete / Residentiel collectif", "Etablissement public", "Hotellerie / Restauration", "Sante", "Enseignement", "Autre"], required: true },
      { name: "luminaire_count", label: "Nombre estime de luminaires", type: "number", required: true },
      { name: "current_type", label: "Typologie actuelle", type: "select", options: ["Neon", "Sodium", "LED partielle", "Autre"], required: true },
      { name: "installation_height", label: "Hauteur d'installation", type: "text", required: false },
      { name: "operating_hours", label: "Horaires de fonctionnement", type: "text", required: false },
      { name: "objective", label: "Objectif", type: "select", options: ["Economies", "Remplacement", "Mise a niveau", "CEE"], required: true },
      { name: "constraints", label: "Contraintes connues", type: "textarea", required: false },
    ],
    suggested_attachments: ["Photos", "Inventaire si existant", "Facture"]
  },
  AUDIT: {
    label: "Audit Energetique",
    fields: [
      { name: "siren", label: "SIREN si connu", type: "text", required: false },
      { name: "multisite", label: "Monosite ou multisite", type: "select", options: ["Monosite", "Multisite"], required: true },
      { name: "global_consumption", label: "Consommation energetique globale estimee", type: "text", required: false },
      { name: "site_count", label: "Nombre de sites", type: "number", required: false },
      { name: "identified_need", label: "Besoin identifie", type: "select", options: ["Obligation", "Optimisation", "Strategie"], required: true },
      { name: "desired_date", label: "Date souhaitee", type: "text", required: false },
      { name: "data_available", label: "Donnees disponibles", type: "select", options: ["Oui", "Non"], required: false },
    ],
    suggested_attachments: ["Consommations", "Liste des sites", "Contact technique / financier"]
  },
  AUTRE: {
    label: "Autre",
    fields: [
      { name: "description", label: "Description libre du besoin", type: "textarea", required: true },
      { name: "site", label: "Site concerne", type: "text", required: false },
    ],
    suggested_attachments: []
  },
};

export function getStatusColor(status) {
  const found = STATUS_OPTIONS.find(s => s.value === status);
  return found ? found.color : "#94A3B8";
}

export function getStatusLabel(status) {
  const found = STATUS_OPTIONS.find(s => s.value === status);
  return found ? found.label : status;
}

export function getSubjectLabel(subject) {
  const found = SUBJECT_OPTIONS.find(s => s.value === subject);
  return found ? found.label : subject;
}
